module.exports = __webpack_public_path__ + "static/lascaux_devanture_bwm-f4305e18d67c3fb632148363189c19ce.jpg";